import React from "react";
import { Outlet } from "react-router-dom";
import toast from "react-hot-toast";
import useAuth from "../hooks/useAuth";
import DialogflowMessenger from "../components/DialogueFlowMessenger";

export default function Layout() {
  const { token, logout, loading } = useAuth();

  return (
    <main className="bg-[#FAFBFC]">
        {/* <DialogflowMessenger/> */}
        <Outlet/>
    </main>
  );
}